import { Box, FormControlLabel, Switch } from "@mui/material";

function SwitchBtn({
  className = "",
  classNameForFormSwitch = "",
  label,
  htmlFor,
  id,
  name,
  checked,
  defaultChecked,
  onChange,
  disabled,
  size = "small",
}) {
  const isControlled = checked !== undefined;
  const wrapperClassName = [className, classNameForFormSwitch]
    .filter(Boolean)
    .join(" ");

  const switchControl = (
    <Switch
      id={id}
      name={name}
      size={size}
      color="primary"
      checked={isControlled ? checked : undefined}
      defaultChecked={!isControlled ? defaultChecked : undefined}
      onChange={onChange}
      disabled={disabled}
      sx={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      inputProps={{ role: "switch" }}
    />
  );

  if (label) {
    return (
      <Box className={wrapperClassName || undefined}>
        <FormControlLabel
          control={switchControl}
          label={label}
          htmlFor={htmlFor || id}
          labelPlacement="start"
          sx={{
            m: 0,
            width: "100%",
            justifyContent: "space-between",
            minWidth: "fit-content",
            gap: 1,
            '& .MuiFormControlLabel-label': {
              fontSize: "14px",
              fontWeight: 500,
              minWidth: "fit-content",
            },
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      className={wrapperClassName || undefined}
      sx={{ display: "inline-flex", alignItems: "center" }}
    >
      {switchControl}
    </Box>
  );
}

export default SwitchBtn;
